import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Event from "../../../../core/consts/analytics-events";
import styles from "./error.module.scss";
import NavBar from "../../../../components/nav-bar/nav-bar";
import Modal from "../../../../components/modal/modal";
import { useDI } from "../../../../core/di";

interface Props {
  error: string;
  onClose: () => void;
}

function Error(props: Props) {
  const { error, onClose } = props;
  const { t } = useTranslation();
  const { analytics } = useDI();

  useEffect(() => {
    analytics?.track(Event.TryagainViewed);
  }, []);

  const handleBack = () => {
    analytics?.track(Event.TryagainBackClicked);
    onClose();
  };

  return (
    <Modal
      data-testid={"login-error"}
      fullWidth={true}
      title={t("tryAgain")}
      navBar={<NavBar mode={"back"} onClick={handleBack} />}
    >
      <p data-testid={"login-error-description"} className={styles.Error}>
        {t(error)}
      </p>
    </Modal>
  );
}

export default Error;
